import React, { useState } from "react";
import AppStackLayout from "component/AppStackLayout/AppStackLayout";
import styles from "./Dashboard.module.css";
import { Container } from "@mui/system";
import Grid from "@mui/material/Grid";
import { LinearProgress, Typography } from "@mui/material";
import AppButton from "component/button/AppButton";
import overview_underlay from "assets/images/overview_underlay.svg";
import Overview from "component/Modules/dashboard/overview/Overview";
import EmptyState from "component/emptyState/EmptyState";
import { useNavigate } from "react-router";
import ApplicationsTable from "./table/ApplicationsTable";
import { useGetApplications } from "api/queries/dashboard/applications/Applications";


function Dashboard() {
  const { data: applications, loading: isLoadingApplications } =
    useGetApplications();
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  return (
    <AppStackLayout
      primaryText={"Information"}
      secondaryText={"You have no outstanding payment to make"}
      openModal={openModal}
      handleClose={() => {
        setOpenModal(false);
      }}
      activeLink="dashboard"
    >
      <div className={styles.dashboard}>
        <Container
          sx={{
            height: "100%",
          }}
          maxWidth="xl"
        >
          <div className={styles.dashboard_content}>
            {/* <Overview setOpenModal={setOpenModal} /> */}
            {isLoadingApplications ? (
              <LinearProgress />
            ) : (
              <div className={styles.table}>
                <div className={styles.heading}>
                  <Typography variant="h6">Application History</Typography>
                  <div className={styles.heading_btn}>
                    <AppButton
                      handleAction={() => {
                        navigate("/applications");
                      }}
                      fullwidth
                      textColor="#FFFFFF"
                      btnBg="#0072CE"
                      btnText="Proceed to Applications"
                    />
                  </div>
                </div>
                {applications?.data?.data?.length > 0 ? (
                  <ApplicationsTable data={applications?.data?.data} />
                ) : (
                  <EmptyState
                    text="No application history yet"
                    btnText="Refresh"
                  />
                )}
              </div>
            )}
          </div>
        </Container>
      </div>
    </AppStackLayout>
  );
}

export default Dashboard;
